export const SALES_PLAN_STATUS_FILTER_ALIASES = {
    pending: ["published", "in_review"],
};

export const SALES_PLAN_STATUS_FILTER_OPTIONS = [
    {
        value: "draft",
        labelKey: "sales_plans.statuses.draft",
    },
    {
        value: "pending",
        labelKey: "sales_plans.statuses.pending",
    },
    {
        value: "approved",
        labelKey: "sales_plans.statuses.approved",
    },
    {
        value: "rejected",
        labelKey: "sales_plans.statuses.rejected",
    },
];

export function expandSalesPlanStatusFilterValue(status) {
    if (!status) {
        return [];
    }

    return SALES_PLAN_STATUS_FILTER_ALIASES[status] || [status];
}
